import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { SuiWalletProvider } from '../SuiWalletProvider.types';

export const isSuiWalletProvider = (
  provider: WalletProvider
): provider is SuiWalletProvider => {
  return provider.chain === 'SUI';
};
